module.exports = __webpack_public_path__ + "static/media/telegram_icon_btn.d0c9e7db.svg";